import { blue, green, orange } from 'common/theme/palette/colors';

/**
 * Speaker name colours, assigned by order of appearance (see the captions reducer) and cycled once
 * exhausted. Three light, non-semantic design-system hues (blue/green/orange 300) that all clear WCAG
 * AA contrast on the dark caption panel. Colour is supplementary — the name text still differentiates
 * speakers for colour-blind users.
 */
export const CAPTION_SPEAKER_COLORS = [
  blue[300], // sky     #84CAFF
  green[300], // green  #6CE9A6
  orange[300], // amber #FEC84B
] as const;

/**
 * How many finalised caption lines to retain for scrollback in the caption region. This is a client-side
 * buffer only (retention/trimming policy is an engineering concern); the region shows the newest lines and
 * scrolls back through the rest.
 */
export const MAX_FINAL_CAPTION_LINES = 50;

/**
 * The same three hues, one-to-one with `CAPTION_SPEAKER_COLORS`, for the light caption panel the host
 * sees backstage. The 300 steps are pastels that vanish on white, so these are the 900/800/800 steps,
 * which clear 7:1 against it.
 */
export const CAPTION_SPEAKER_COLORS_LIGHT = [
  blue[900], // #194185
  green[800], // #05603A
  orange[800], // #93370D
] as const;
